import React from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import LoggedInLayout from "../layout";
import Connections from "../pages/Connections/";
import Contacts from "../pages/Contacts/";
import Dashboard from "../pages/Dashboard/";
import Login from "../pages/Login/";
import Queues from "../pages/Queues/";
import QuickAnswers from "../pages/QuickAnswers/";
import Schedules from "../pages/Schedules/";
import SendMassMessage from "../pages/SendMassMessage";
import SettingMessage from "../pages/SettingMessage";
import Settings from "../pages/Settings/";
import ShippingReport from "../pages/ShippingReport";
import Signup from "../pages/Signup/";
import Tags from "../pages/Tags/";
import Tickets from "../pages/Tickets/";
import Users from "../pages/Users";
import Route from "./Route";
import TagsReport from "../pages/TagsReport";
import InternalChat from "../pages/InternalChat";
import ControlPanel from "../pages/ControlPanel";
import CalendarSettings from "../pages/CalendarSettings";
import Calendar from "../components/Calendar";
import EventSearch from "../components/EventSearch";
import SelfScheduleList from "../components/SelfScheduleList";
import Faq from "../pages/Faq";
import { FormatQuote } from "@material-ui/icons";
import Api from "../pages/Api";
import Sms from "../pages/Sms";
import SmsSettings from "../pages/SmsSettings";
import FileManager from "../pages/FileManager";
import ModuleGuard from "../components/ModuleGuard";
import BlockedAccess from "../pages/BlockedAccess";
import useSystemBlock from "../hooks/useSystemBlock";
import Backups from "../pages/Backups/";

const RoutesContent = () => {
  const { isBlocked } = useSystemBlock();

  if (isBlocked) {
    return <BlockedAccess />;
  }

  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/signup" component={Signup} />
      <WhatsAppsProvider>
        <LoggedInLayout>
          <Route exact path="/" component={Dashboard} isPrivate />
          <Route
            exact
            path="/tickets/:ticketId?"
            component={Tickets}
            isPrivate
          />
          <Route
            exact
            path="/connections"
            component={Connections}
            isPrivate
          />
          <Route exact path="/contacts" component={Contacts} isPrivate />
          <Route exact path="/users" component={Users} isPrivate />
          <Route
            exact
            path="/quickAnswers"
            component={QuickAnswers}
            isPrivate
          />
          <Route exact path="/Settings" component={Settings} isPrivate />
          <Route exact path="/Queues" component={Queues} isPrivate />
          <Route exact path="/tags" component={Tags} isPrivate />
          <Route exact path="/Tags-Reports" component={TagsReport} isPrivate />
          <Route exact path="/schedules" component={Schedules} isPrivate />
          <Route exact path="/BulkMessage" component={SendMassMessage} isPrivate />

          <Route exact path="/ShippingReport" component={ShippingReport} isPrivate />
          <Route exact path="/SettingsMessage" component={SettingMessage} isPrivate />
          
          <Route exact path="/chats" isPrivate>
            <ModuleGuard module="moduleInternalChat">
              <InternalChat />
            </ModuleGuard>
          </Route>
          
          <Route exact path="/ControlPanel" component={ControlPanel} isPrivate />
          
          <Route exact path="/agendas" isPrivate>
            <ModuleGuard module="moduleCalendar">
              <CalendarSettings />
            </ModuleGuard>
          </Route>
          <Route exact path="/agendas/:agendaId" isPrivate>
            <ModuleGuard module="moduleCalendar">
              <Calendar />
            </ModuleGuard>
          </Route>
          
          <Route exact path="/auto-agendamentos" isPrivate>
            <ModuleGuard module="moduleAutoSchedule">
              <SelfScheduleList />
            </ModuleGuard>
          </Route>
          
          <Route exact path="/EventSearch" component={EventSearch} isPrivate />
          <Route exact path="/faq" component={Faq} isPrivate />
          <Route exact path="/api" component={Api} isPrivate />
          <Route exact path="/file-manager" component={FileManager} isPrivate />
          
          <Route exact path="/sms" isPrivate>
            <ModuleGuard module="moduleSms">
              <Sms />
            </ModuleGuard>
          </Route>
          <Route exact path="/sms-settings" isPrivate>
            <ModuleGuard module="moduleSms">
              <SmsSettings />
            </ModuleGuard>
          </Route>
          
          <Route exact path="/backups" component={Backups} isPrivate />
        </LoggedInLayout>
      </WhatsAppsProvider>
    </Switch>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesContent />
        <ToastContainer autoClose={3000} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
